export enum ReservationStatus {
  NEW = "NEW",
  SELF = "SELF",
  INVITE_SELF = "INVITE_SELF",
  PENDING = "PENDING",
}
